import { useEffect } from 'react';

const VoiceRecorder = ({ onResponse, setAppState }) => {
  useEffect(() => {
    let mediaRecorder = null;
    let audioChunks = [];

    const startRecording = async () => {
      audioChunks = [];

      if (setAppState) setAppState('listening');

      if (window.currentStream) {
        window.currentStream.getTracks().forEach(track => track.stop());
      }

      if (navigator?.mediaDevices?.getUserMedia) {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        window.currentStream = stream;

        let mimeType = '';
        if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
          mimeType = 'audio/webm;codecs=opus';
        } else if (MediaRecorder.isTypeSupported('audio/webm')) {
          mimeType = 'audio/webm';
        } else {
          alert('🎤 Your browser does not support audio recording.');
          return;
        }
        console.log("🎙️ Using MIME type:", mimeType);
        mediaRecorder = new MediaRecorder(stream, { mimeType });
        audioChunks = [];

        mediaRecorder.start();

        mediaRecorder.addEventListener("dataavailable", event => {
          audioChunks.push(event.data);
        });

        mediaRecorder.addEventListener("stop", async () => {
          const audioBlob = new Blob(audioChunks, { type: mimeType });
          const formData = new FormData();
          console.log('🟡 VoiceRecorder stopped');
          console.log('🔈 Blob type:', audioBlob.type);
          console.log('📦 Blob size:', audioBlob.size);
          formData.append('audio', audioBlob);

          if (setAppState) setAppState('processing');

          try {
            console.log('📤 Sending audio to backend...');
            const res = await fetch('https://aitoxa-pro-backend.onrender.com/process', {
              method: 'POST',
              body: formData,
            });

            const data = await res.json();
            console.log("🧠 Response from backend:", data);

            if (data.voiceUrl) {
              if (setAppState) setAppState('awaitingPlayback'); // Signal to parent
              if (onResponse) onResponse(`https://aitoxa-pro-backend.onrender.com${data.voiceUrl}`); // Let parent handle the playback
            } else {
              console.warn("❌ No voiceUrl returned");
              if (setAppState) setAppState('idle');
              alert("Voice processing failed or returned no voice.");
            }
          } catch (err) {
            console.error('❌ Voice processing failed:', err);
            if (setAppState) setAppState('idle');
            alert("Error processing your voice. Please try again.");
          }
        });

        setTimeout(() => {
          if (mediaRecorder && mediaRecorder.state === 'recording') {
            mediaRecorder.stop();
          }
        }, 4000); // Record for 4 seconds
      }
    };

    window.startRecording = startRecording;
    window.stopRecording = () => {
      if (mediaRecorder && mediaRecorder.state === 'recording') {
        mediaRecorder.stop();
        mediaRecorder = null;
      }
    };
  }, [onResponse, setAppState]);

  return null;
};

export default VoiceRecorder;